import { ActionType, createReducer } from 'typesafe-actions';
import { saveWinnerToStoreAction } from './actions';
import { IWinnerState } from './types';

export const winnerState: IWinnerState = {
  winner: null,
};

const actions = {
  saveWinnerToStoreAction,
};

export const winnerReducer = createReducer<IWinnerState, ActionType<typeof actions>>(
  winnerState,
).handleAction(saveWinnerToStoreAction, (state, { payload: { winner } }) => ({
  ...state,
  winner,
}));
